import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TimezoneSettingsState = {
  timezoneSettings: {},
  timezoneSettingsLoading: false,
}

export const TimezoneSettingsActions = {
  createTimezoneSettings: async ({ commit }, value) => {
    commit('setTimezoneSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'timezone',
        value,
      }).
      then(({ data }) => commit('setTimezoneSettings', data)).
      catch(handleError).
      finally(_ => commit('setTimezoneSettingsLoading', false))
  },

  getTimezoneSettings: async ({ commit }) => {
    commit('setTimezoneSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/timezone').
      then(({ data }) => {
        commit('setTimezoneSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setTimezoneSettingsLoading', false))
  },

  updateTimezoneSettings: async ({ getters, commit }, value) => {
    commit('setTimezoneSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.timezoneSettingsId}`, {
        name: 'timezone',
        value,
      }).
      then(({ data }) => commit('setTimezoneSettings', data)).
      catch(handleError).
      finally(_ => commit('setTimezoneSettingsLoading', false))
  },

  deleteTimezoneSettings: async ({ getters, commit }) => {
    commit('setTimezoneSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.timezoneSettingsId}`).
      then(({ data }) => commit('setTimezoneSettings', data)).
      catch(handleError).
      finally(_ => commit('setTimezoneSettingsLoading', false))
  },
}

export const TimezoneSettingsMutations = {
  setTimezoneSettings: (state, payload) => { state.timezoneSettings = payload },
  setTimezoneSettingsLoading: (state, payload) => { state.timezoneSettingsLoading = payload },
  setTimezoneSettingsValue: (state, payload) => { state.timezoneSettings.value = payload },
}

export const TimezoneSettingsGetters = {
  timezoneSettings: state => state.timezoneSettings,
  timezoneSettingsId: state => state.timezoneSettings?.id,
  timezoneSettingsLoading: state => state.timezoneSettingsLoading,
  timezoneSettingsValue: state => state.timezoneSettings?.value,
}
